/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookClosed: {
  name: 'book-closed';
  data: string;
} = {
  name: 'book-closed',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5A1.5 1.5 0 0 0 1.5 2v12A1.5 1.5 0 0 0 3 15.5h10a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 13 .5H3Zm10.5 11V2a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v9.585c.156-.055.325-.085.5-.085h10.5ZM2.5 13a.5.5 0 0 1 .5-.5h10.5V14a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1Z" fill="currentColor"/></svg>`,
};
